import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_REVISE_SALARY);
var axios_instance_delete_revised_salary = get_axios_instance(api_variables.SERVICE_DELETE_REVISED_SALARY)
var axios_instance_ctc = get_axios_instance(api_variables.SERVICE_CALCULATE_CTC);
var axios_instance_new_revise_salary = get_axios_instance(api_variables.SERVICE_EMPLOYEE_REVISE_SALARY);
var axios_instance_search_employee_name_code = get_axios_instance(api_variables.SERVICE_REVISE_SALARY_SEARCH_EMPLOYEE_NAME_CODE);
var axios_instance_search_filtered_employee = get_axios_instance(api_variables.SERVICE_FILTERED_REVISE_SALARY_EMPLOYEE);
var axios_instance_revoke_revise_salary = get_axios_instance(api_variables.SERVICE_REVOKE_REVISE_SALARY);
var axios_instance_download_revise_salary = get_axios_instance(api_variables.SERVICE_SALARY_REVISION_DOWNLOAD);
var axios_instance_bulk_upload_revise_salary = get_axios_instance(api_variables.SERVICE_SALARY_REVISION_BULK_UPLOAD);
var axios_instance_get_searched_employee = get_axios_instance(api_variables.SERVICE_GET_SEARCHED_EMPLOYEE);
var axios_instance_get_salary_rivision_deletion_template = get_axios_instance(api_variables.SERVICE_SALARY_REVISION_DELETION_DOWNLOAD);
var axios_instance_salary_rivision_deletion_upload = get_axios_instance(api_variables.SERVICE_SALARY_REVISION_DELETION_UPLOAD);

const _pk_name = "id";

const state = {
  data: [],
  revisesalary: [],
  calculatedData: [],
  isFetching: false,
  isSaving: false,
  isDeleting: false
};
const mutations = {
  set: (state, payload) => {
    state.data = payload;
  },
  setReviseSalary: (state, payload) => {
    if (payload) {
      state.revisesalary = payload;
    }
  },
  getCalculatedCtcData: (state, payload) => {
    if (payload) {
      state.calculatedData = payload;
    }
  },
  addReviseSalary: (state, payload) => {
    state.revisesalary = payload;
  },
  updateReviseSalary: (state, payload) => {
    // for(let i=0; i<state.data.length; i++) {
    //   if(state.data[i][_pk_name] === payload.id) {
    //     state.data.splice(i, 1, payload);
    //   }
    // }
    state.revisesalary = payload
  },
  removeEmployeeById: (state, payload) => {
    for (let i = 0; i < state.data.length; i++) {
      if (state.data[i][_pk_name] == payload) {
        state.data.splice(i, 1);
      }
    }
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },
  setSaving: (state, payload) => {
    state.isSaving = payload;
  },
  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}
const actions = {

    async fetchFilteredEmployeesList({ commit }, payload) {
      try {
        commit("setFetching", true);
        let res = await axios_instance_search_filtered_employee.get('/', {
          params: {
              le_id: payload.le_id,
              paygroups: payload.paygroups ? payload.paygroups : [],
              bands: payload.bands ? payload.bands : [],
              designations: payload.designations ? payload.designations : [],
              locs: payload.locs ? payload.locs : [],
              grades: payload.grades ? payload.grades : [],
              page: payload.page
          }
        });
        commit("setFetching", false);
        return res;
      } catch (err) {
        throw errorHandler(err.response);
      }
    },


  // PL_3029
  async fetchSearchEmployeeList({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_search_employee_name_code.get('/', {
        params: {
          le_id: payload.le_id,
          key: payload.key,
        }
      });
      commit("setFetching", false);
      if (res.status) {
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  // PL_3029
  async deleteReviseSalary({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_delete_revised_salary.post(``,{
          employee_id:payload.employee_id,
          ip_address:"ip not found",
          email:payload.email
        }
      );
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchReviseSalary({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
          emp_id: payload
        }
      });
      commit("setFetching", false);
      if (res.status) {
        commit("setReviseSalary", res.data.rows);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchCalculatedCtc({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_ctc.get('/', {
        params: {
          ctc: payload
        }
      });
      commit("setFetching", false);
      if (res.status) {
        commit("getCalculatedCtcData", res.data.rows);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },


  async calculateReviseSalary({ commit }, payload) {
    try {
      let res = await axios_instance_new_revise_salary.post('/', payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
 
  async create({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      if (res.status) {
        commit("addReviseSalary", payload);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async RevokeReviseSalary({ commit }, payload){
    //console.log("[revokerevisesalary] Calling API...");
    try{
      commit("setSaving", true);
      let res = await axios_instance_revoke_revise_salary.put('/',payload);
      commit("setSaving", false);
      if(res.status){
        commit("RevokeReviseSalary", res);
      }
      return res;
    } catch (err){
      throw errorHandler(err.response);
    }
  },
  async update({ commit }, [id, payload]) {
    try {
      commit("setSaving", true);
      let res = await axios_instance.put('/:' + `${id}`, payload);
      commit("setSaving", false);
      if (res.status) {
        commit("updateReviseSalary", res);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async delete({ commit }, payload) {
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status) {
        commit("removeReviseSalary", payload.id);
      }
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async fetchwithctc({ commit }, payload) {
    try {
      // commit("setFetching", true); params:{...payload}
      //   let res = await salarystructure_axios_instance.get(`/`, {
      //     params: payload
      //   });
      //  commit("setFetching", false);
      //   //console.log("[state/onboard/settings/salary_structure/fetchwithctc] res: ", res);
      //   if(res.status == 200) {
      //     // commit("set", [res.data.rows, payload]);
      //     return res.data.payload
      //   }
      //   return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  
  async getEmployeeTemplate({commit},payload) {
    try {
        //console.log("Inside Report.js");
      let res = await axios_instance_download_revise_salary.get(`/`, {
        params: {
          le_id: payload
        }
      });
     // let res = await axios_instance_download_revise_salary.get(`/${payload}`);
      //console.log(res);

      if (res.data.status) {
        const link = document.createElement("a");
        //console.log(res);
        link.href = res.data.payload;
        link.setAttribute("download", "salaryRevisionTemplate"+ ".xlsx"); //or any other extension
        document.body.appendChild(link);
        link.click();
    }
    } catch (err) {
        throw errorHandler(error);
    }
  },

  async uploadTemplate({ commit }, payload) {
    try {
        // commit("setFetching", true);
        let res = await axios_instance_bulk_upload_revise_salary.post(``,payload);
        // commit("setFetching", false);
        return res;
    } catch (err) {
        throw errorHandler(err.response);
    }
},

async getSearchedEmployees({ commit }, payload) {
  let res = await axios_instance_get_searched_employee.get('/', {
    params: {
      le_id: payload.le_id,
      key: payload.key
    }
  })
  return res;
},

async getSalaryDeletionTemplate({ commit }, le_id) {
  try {
    let res = await axios_instance_get_salary_rivision_deletion_template.get(`/`, {
      params: {
        le_id: le_id
      }
    });
    if (res.data.status) {
      const link = document.createElement("a");
      link.href = res.data.payload;
      link.setAttribute("download", "salaryRevisionDeletionTemplate"+ ".xlsx");
      document.body.appendChild(link);
      link.click();
  }
  } catch (err) {
      throw errorHandler(error);
  }
},

async uploadSalaryDeletionTemplate({ commit }, payload) {
  try {
    let res = await axios_instance_salary_rivision_deletion_upload.post(``, payload);
    return res;
  } catch (err) {
      throw errorHandler(err.response);
  }
},
}

export default {
  namespaced: true,
  state, mutations, actions
}
